/* eslint-disable @typescript-eslint/no-explicit-any */
import { Options } from '@/core';

export const mockParent: any = { id: 1, name: 'parent' };
export const mockUncle: any = { id: 2, name: 'uncle' };

export const mockGuardians: any = [mockParent, mockUncle];

export const mockGuardiansData: Options<any> = [mockParent, mockUncle].map(({ id, name }) => ({ text: name, value: id.toString() }));
